<ng-container *ngIf="layout.chatbox | async">
  <hr *ngIf="layout.isMobile | async" class="cmx-navbar__separator" />
  <div (click)="chatboxClick()" class="cmx-navbar__chatbox" [ngClass]="{ 'cmx-navbar__chatbox--rtl': isRtl }">
    <div class="cmx-navbar__chatbox-icon">
      <div class="cmx-icon-chat-filled"></div>
    </div>
    <div
      class="cmx-navbar__chatbox-label"
      [ngClass]="{ 'cmx-navbar__chatbox-label--collapsed': isCollapsed && !isMobile }"
    >
      {{ layout.chatboxLabel | async | ellipsis: 14 }}
    </div>
  </div>
</ng-container>
